import { CookieStorage, ICookieStorageData } from 'amazon-cognito-identity-js';
import type { ResponseCookie } from 'next/dist/compiled/@edge-runtime/cookies';
import { NextRequest } from 'next/server';

const EXPIRATION_IN_DAYS = 365;
const ONE_DAY = 60 * 60 * 24;

export function getCookieSettings(domainUrl: string, format?: 'generic'): ICookieStorageData;
export function getCookieSettings(domainUrl: string, format?: 'nextjs'): ICookieStorageData;
export function getCookieSettings(req: NextRequest, format: 'nextjs'): ResponseCookie;
export function getCookieSettings(
  urlOrRequest: string | NextRequest,
  format: 'nextjs' | 'generic' = 'generic',
): ICookieStorageData | ResponseCookie {
  const domainUrl = typeof urlOrRequest === 'string' ? urlOrRequest : urlOrRequest.nextUrl.origin;
  const isLocalhost = domainUrl.includes('localhost');

  const url = new URL(domainUrl);

  let domain;
  if (isLocalhost) {
    domain = 'localhost';
  } else if (url.host.includes('simplebooking.io')) {
    domain = url.host.split('.').slice(-3).join('.');
  } else if (url.host.includes('vercel.app')) {
    domain = url.host;
  } else {
    domain = url.host.split('.').slice(-2).join('.');
  }

  const cookieOptions = {
    domain,
    secure: !isLocalhost,
    path: '/',
    sameSite: isLocalhost ? ('lax' as const) : ('none' as const),
  };

  if (format === 'nextjs') {
    return {
      ...cookieOptions,
      maxAge: EXPIRATION_IN_DAYS * ONE_DAY,
    };
  }

  return {
    ...cookieOptions,
    expires: EXPIRATION_IN_DAYS,
  };
}

/**
 * To mitigate HTTP 431 (header too large) errors, we want to avoid redundant cookies.
 * The internal CookieStorage implementation of amplify gets extended and calls to set any of the @ignoredValues are returned early.
 */
export class MinimizedCookieStorage extends CookieStorage {
  private static ignoredValues = ['userData'];

  setItem(key: string, value: string) {
    if (MinimizedCookieStorage.ignoredValues.some((value) => key.includes(value))) {
      return;
    }

    super.setItem(key, value);
  }
}
